import getElementPosition from './get-element-position';
import {isHTMLElement} from 'type-guards/lib/type-guards';

export default function getVerticalAscendingOrderOfElements(arr: HTMLElement[]) {
  return arr.filter(isHTMLElement).sort((a, b) => {
    return getElementPosition(a).y < getElementPosition(b).y ? -1 : 1;
  });
}
